import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export interface HistorialExtintor {
  id?: number;
  placa: string;
  idextintor: number;
  frecarga: string;
  vrecarga: string;
  fecha_registro: string;
  estado?: number;
  estado_fechas?: string;
}

@Injectable({
  providedIn: 'root',
})
export class HistorialExtintorService {
  private apiUrl =  `${environment.apiUrl}/api/historial_extintor`; 


  constructor(private http: HttpClient, private authService: AuthService) {}

  /** Crear un historial */
  create(historial: HistorialExtintor): Observable<HistorialExtintor> {
    return this.http.post<HistorialExtintor>(this.apiUrl, historial);
  }

  /** Obtener historial por ID de extintor */
  getByIdExtintor(id: number): Observable<HistorialExtintor> {
    return this.http.get<HistorialExtintor>(`${this.apiUrl}/${id}`);
  }

  /** Obtener todos los historiales activos y estadísticas */
  getAll(): Observable<{ historial: HistorialExtintor[]; estadisticas: any }> {
    return this.http.get<{ historial: HistorialExtintor[]; estadisticas: any }>(this.apiUrl);
  }

  /** Actualizar historial por ID */
  update(id: number, data: Partial<HistorialExtintor>): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data);
  }

  /** Eliminar lógicamente (inactivar) por ID */
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  /** Obtener historiales por placa */
  getByPlaca(placa: string): Observable<HistorialExtintor[]> {
    return this.http.get<HistorialExtintor[]>(`${this.apiUrl}/placa/${placa}`);
  }

  /** Inactivar por ID de extintor */
  inactivarPorIdExtintor(idextintor: number): Observable<any> {
  return this.http.put(`${this.apiUrl}/estado/${idextintor}`, { estado: 0 });
}
}
